const KegSizesEndpoint = {
  index () {
    return {
      url: `/account_sizes`,
      method: 'GET'
    }
  }
}

export default KegSizesEndpoint



// WEBPACK FOOTER //
// ./src/persistence/KegSizesEndpoint.js